import {call, put, takeLatest} from "redux-saga/effects";
import {
    accountExistsWithPhoneNumber,
    CHECK_PHONE_NUMBER,
    checkIfPhoneNumberExistsFailed
} from "../actions/practice.action";
import {callFinished, callInProgress} from "../actions/loading.action";
import {
    ICheckIfEMRNumberExists,
    ICheckIfPhoneNumberExists,
    ICheckInFlowCreatePatientRequest,
    IPatientCheckInResponse
} from "../../models";
import {apiHttpClient} from "../../lib";
import {AxiosResponse} from "axios";
import {
    accountExistsWithEMRNumber,
    checkIfEMRNumberExistsFailed,
    CREATE_PROFILE_VIA_CHECK_IN_FLOW,
    createProfileViaCheckInFlowFailed,
    createProfileViaCheckInFlowSuccess,
    VERIFY_CHECK_IN,
    verifyCheckInFailed,
    verifyCheckInSuccess
} from "../actions/signup.action";

const apiVerifyCheckIn = (payload: {checkInId: string}) => {
    console.log(`signup saga :: apiVerifyCheckIn :: ${JSON.stringify(payload)}`)
    return apiHttpClient.post<ICheckIfEMRNumberExists>(`/patient-check-in/${payload.checkInId}/verify`)
        .then((response: AxiosResponse) => {
            return response.data.data as IPatientCheckInResponse
        }).catch((e) => {
            console.log(e)
            console.log("FailedVerifyingCheckIn")
            throw e
        });
}

function* verifyCheckIn(action: { type: string,  payload: {checkInId: string} }) {
    try {
        console.log(`signup saga ::verifyCheckIn`)
        yield put(callInProgress())
        const checkInResponse: IPatientCheckInResponse = yield call(apiVerifyCheckIn, action.payload)
        console.log(`signup saga ::checkIfEMRNumberExists->\n: ${checkInResponse} `)
        yield put(verifyCheckInSuccess({checkInResponse}));
    } catch (e: any) {
        console.log(e)
        const msg = e?.response?.data?.error
        yield put(verifyCheckInFailed({error: msg ? msg : "Error verifying check-in!"}))
    } finally {
        yield put(callFinished())
    }
}

const apiCreateProfileViaCheckInFlow = (payload: {checkInId: string, patientData: ICheckInFlowCreatePatientRequest}) => {
    console.log(`signup saga :: apiCreateProfileViaCheckInFlow :: ${JSON.stringify(payload)}`)
    return apiHttpClient.post<ICheckIfPhoneNumberExists>(`/patient-check-in/${payload.checkInId}/create-patient`, payload.patientData)
        .then((response: AxiosResponse) => {
            return response.data.data as IPatientCheckInResponse
        }).catch((e) => {
            console.log(e)
            console.log("FailedCreatingProfileViaCheckInFlow")
            throw e
        });
}

function *createProfileViaCheckInFlow(action: { type: string, payload: { checkInId: string, patientData: ICheckInFlowCreatePatientRequest } }) {
    try {
        yield put(callInProgress());
console.log(`signup saga :: createProfileViaCheckInFlow`)
        const checkInResponse: IPatientCheckInResponse = yield call(apiCreateProfileViaCheckInFlow, action.payload);
        console.log(`signup saga :: createProfileViaCheckInFlow->\n: ${checkInResponse} `)
        yield put(createProfileViaCheckInFlowSuccess({checkInResponse}));
    } catch (e: any) {
        console.log(e)
        const msg = e?.response?.data?.error
        yield put(createProfileViaCheckInFlowFailed({error: msg ? msg : "Error creating profile via check-in flow!"}))
    } finally {
        yield put(callFinished())
    }
}

export default function* signupSaga() {
    yield takeLatest(VERIFY_CHECK_IN, verifyCheckIn)
    yield takeLatest(CREATE_PROFILE_VIA_CHECK_IN_FLOW, createProfileViaCheckInFlow)
}
